/**
 * Atribución "Desarrollado por DL Soft" según las Brand Guidelines de
 * dlsoft.dev (https://dlsoft.dev/design#powered).
 *
 * - Siempre enlaza a https://dlsoft.dev con target="_blank" + rel seguro.
 * - Variantes para fondos claros y oscuros.
 * - Tamaños sm / md / lg.
 */
interface PoweredByDLSoftProps {
  theme?: "light" | "dark";
  variant?: "minimal" | "simple" | "badge" | "pill";
  size?: "sm" | "md" | "lg";
  className?: string;
  text?: string;
}

const sizeMap = {
  sm: { logo: "h-6", text: "text-xs", padding: "px-2.5 py-1" },
  md: { logo: "h-8", text: "text-sm", padding: "px-3 py-1.5" },
  lg: { logo: "h-10", text: "text-base", padding: "px-4 py-2" },
};

export default function PoweredByDLSoft({
  theme = "light",
  variant = "simple",
  size = "md",
  className = "",
  text = "Desarrollado por",
}: PoweredByDLSoftProps) {
  const sizes = sizeMap[size];
  // Light theme = fondo claro → logo dark
  // Dark  theme = fondo oscuro → logo light
  const logoSrc =
    theme === "light"
      ? "/branding/dlsoft/logo-dark.svg"
      : "/branding/dlsoft/logo-light.svg";

  const textColor = theme === "light" ? "text-gray-500" : "text-gray-300";
  const hoverColor =
    theme === "light" ? "hover:text-gray-700" : "hover:text-white";

  let containerClass = `inline-flex items-center gap-2 transition-all ${textColor} ${hoverColor}`;

  if (variant === "badge") {
    containerClass += ` ${sizes.padding} rounded-lg ${
      theme === "light"
        ? "bg-gray-50 border border-gray-200 hover:border-gray-300"
        : "bg-white/5 border border-white/10 hover:bg-white/10"
    }`;
  } else if (variant === "pill") {
    containerClass += ` ${sizes.padding} rounded-full ${
      theme === "light"
        ? "bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200"
        : "bg-gradient-to-r from-white/5 to-white/10 border border-white/10"
    }`;
  }

  return (
    <a
      href="https://dlsoft.dev"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Desarrollado por DL Soft - dlsoft.dev"
      className={`${containerClass} ${className}`}
    >
      {variant !== "minimal" && (
        <span className={`${sizes.text} font-medium`}>{text}</span>
      )}
      {variant === "minimal" ? (
        <span className={`${sizes.text} font-semibold`}>
          {text} <span className="underline">DL Soft</span>
        </span>
      ) : (
        <img
          src={logoSrc}
          alt="DL Soft"
          className={`${sizes.logo} w-auto`}
          loading="lazy"
        />
      )}
    </a>
  );
}
